import {
  GET_PUBLIC_COMMENTS,
  GET_ADMIN_COMMENTS,
  TOGGLE_COMMENT_LOADING,
} from "../actions/types";

const initialState = {
  public_comments: [],
  all_admin_comments: [],
  comment_loading: false,
};

export default function commentReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PUBLIC_COMMENTS:
      return { ...state, public_comments: action.payload };
    case GET_ADMIN_COMMENTS:
      return { ...state, all_admin_comments: action.payload };
    case TOGGLE_COMMENT_LOADING:
      return { ...state, comment_loading: !state.comment_loading };
    default:
      return state;
  }
}
